module.exports = __webpack_public_path__ + "media/calling_ringtone.b68216c0.mp3";